/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */
import {InvoiceAbstractTotalService} from "./AbstractTotalService";
import ServiceFactory from "../../../../../framework/factory/ServiceFactory";
import NumberHelper from "../../../../../helper/NumberHelper";
import OrderItemService from "../../OrderItemService";

export class InvoiceCostService extends InvoiceAbstractTotalService {
    static className = 'InvoiceCostService';

    /**
     * Collect invoice cost
     *
     * @param invoice
     * @return {InvoiceCostService}
     */
    collect(invoice) {
        let baseInvoiceTotalCost = 0;
        if (invoice.items && invoice.items.length) {
            invoice.items.forEach(item => {
                if (!OrderItemService.getHasChildren(item, invoice.order)) {
                    baseInvoiceTotalCost = NumberHelper.addNumber(
                        baseInvoiceTotalCost, NumberHelper.multipleNumber(item.base_cost, item.qty)
                    );
                }
            });
        }
        invoice.base_cost = baseInvoiceTotalCost;
        return this;
    }
}

/** @type InvoiceCostService */
let invoiceCostService = ServiceFactory.get(InvoiceCostService);

export default invoiceCostService;


// WEBPACK FOOTER //
// ./src/service/sales/order/invoice/total/CostService.js